<template>
  <v-alert v-if="canRender && !isParagraphText" text :color="getColorAffichage" :type="defineType" class="my-4">
    <div v-html="ressource.texte"></div>
  </v-alert>
  <div v-else-if="canRender" class="my-4">
    <div v-html="ressource.texte"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      defaultRessourceNoCodeFound: {
        texte: '<span style="color:black;">Ressource manquante : ' + this.code + "</span>",
      },
      defaultRessourceTexteEmpty: {
        texte: '<span style="color:black;">Pas de texte renseigné pour le code : ' + this.code + "</span>",
      },
    }
  },
  props: {
    code: String
  },
  computed: {
    ...mapGetters({ ressources: "ParamFormulaireDeprecated/ressources" }),
    ressource() {
      if (this.ressources?.has(this.code)) {
        var ressource = this.ressources.get(this.code)
        // Si l'option "masquer" est mise a false, et que le texte est vide, un message de warning s'affiche
        if (ressource.texte == null || ressource.texte == "" && ((ressource.masquer == null) || (ressource.masquer != null && !ressource.masquer)) ) {
          return this.defaultRessourceTexteEmpty
        }
        return ressource
      } else {
        return this.defaultRessourceNoCodeFound
      }
    },

    getColorAffichage() {
      if (this.ressource) {
        switch (this.ressource.typeInfoBulle) {
          case this.$paramFormulaire.infoText:
            return this.$paramFormulaire.infoColor
          case this.$paramFormulaire.avertissementText:
            return this.$paramFormulaire.warningColor
          case this.$paramFormulaire.erreurText:
            return this.$paramFormulaire.errorColor
          case this.$paramFormulaire.successText:
            return this.$paramFormulaire.successColor
          default:
            return this.$paramFormulaire.defaultColor
        }
      }
    },
    defineType() {
      // Utilisé pour remplacer l'icone de warning par celle du danger
      return this.ressource.typeInfoBulle == this.$paramFormulaire.avertissementText
        ? this.$paramFormulaire.erreurText
        : this.ressource.typeInfoBulle
    },
    // Si l'option "masquer" est mise a true, le composant n'est pas render
    canRender() {
      if (this.ressource.masquer != null && this.ressource.masquer) {
        return false;
      }
      return true;
    },
    isParagraphText() {
      if (this.ressource.typeInfoBulle == this.$paramFormulaire.paragraphText) {
        return true;
      }
      return false;
    },
  },
}
</script>

<style></style>
